import script from "./RatingQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingQuestion.vue?vue&type=script&setup=true&lang=js"

import "./RatingQuestion.vue?vue&type=style&index=0&id=25be235e&scoped=true&lang=css"

import exportComponent from "/var/www/frontend/mobileproject/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25be235e"]])

export default __exports__